/**
 * Gets the appropriate date for sorting from a card
 */
function getCardDate(card: Card): Date {
  // For events, prefer dateInitial, otherwise use meta.firstPublishedAt
  if (card.__typename === 'DatoCmsPctEvent') {
    const eventCard = card as Card & { dateInitial?: string }
    if (eventCard.dateInitial) {
      return new Date(eventCard.dateInitial)
    }
  }
  const date = card.meta?.firstPublishedAt ?? card.meta?.createdAt ?? 0
  return new Date(date)
}

/**
 * Filters and sorts an array of cards.
 *
 */
export function filterAndSortCards(items: Card[]): Card[] {
  return items
    .filter((item) =>
      process.env.NODE_ENV !== 'development'
        ? item?.meta?.firstPublishedAt !== null ||
          item?.meta?.createdAt !== null
        : true
    )
    .sort((a, b) => {
      const aDate = getCardDate(a)
      const bDate = getCardDate(b)
      return bDate.getTime() - aDate.getTime()
    })
}

/**
 * Sorts and filters related content cards.
 */
export function sortRelatedContent({
  results,
  nodesGroups
}: {
  results?: number
  nodesGroups: readonly Card[][]
}): Card[] {
  const related = nodesGroups.reduce((acc: Card[], nodesGroup: Card[]) => {
    const sortedNodes = Array.isArray(nodesGroup)
      ? filterAndSortCards([...nodesGroup])
      : []
    return [...acc, ...sortedNodes]
  }, [])

  return related.slice(0, results ?? related.length)
}
